import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Legacy from "@/components/Legacy";
import Yachts from "@/components/Yachts";
import Brands from "@/components/Brands";
import AfterSales from "@/components/AfterSales";
import Contact from "@/components/Contact";
import { scrollToSection } from "@/components/Navbar";

export default function Home() {
  const { state } = useLocation();

  useEffect(() => {
    if (!state?.scrollTo) return;
    const t1 = setTimeout(() => scrollToSection(state.scrollTo), 150);
    const t2 = setTimeout(() => scrollToSection(state.scrollTo, true), 1900);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [state]);

  return (
    <>
      <Hero />
      <Marquee />
      <Legacy />
      <Brands />
      <Yachts />
      <AfterSales />
      <Contact />
    </>
  );
}
